export default __webpack_public_path__ + "static/media/cloudcommerce.9b3a7a9b.png";